import { css } from '@emotion/react';
import { theme } from '@web/features/theme';
import { swalStyles } from '@web/services/swal';

/**
 * Eric Meyer's CSS Reset | v2.0 | 20110126 | License: none (public domain)
 * See: http://meyerweb.com/eric/tools/css/reset/
 */
export const cssReset = css`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;

export const globalStyles = css`
  ${cssReset}
  ${swalStyles}

  *,
  *:before,
  *:after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: ${theme.fonts.body};
  }

  body {
    padding: 5%;
    min-height: 100vh;

    position: relative;
  }

  body,
  main {
    max-width: 100vw;
    padding-bottom: ${theme.space[12]};
    color: ${theme.colors.text};
    z-index: ${theme.zIndices.auto};
    position: relative;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: ${theme.fontWeights.normal};
    letter-spacing: ${theme.letterSpacings.wider};
    line-height: ${theme.lineHeights.short};
    color: ${theme.colors.text};
    font-family: ${theme.fonts.heading};
  }

  h1 {
    font-size: ${theme.fontSizes['3xl']};

    &.display {
      font-size: clamp(${theme.fontSizes.lg}, 8vw, ${theme.fontSizes['5xl']});
    }
  }
  h2 {
    font-size: ${theme.fontSizes['2xl']};
  }
  h3 {
    font-size: ${theme.fontSizes.xl};
  }
  h4 {
    font-size: ${theme.fontSizes.lg};
  }
  h5 {
    font-size: ${theme.fontSizes.md};
  }
  h6 {
    font-size: ${theme.fontSizes.sm};
  }

  p,
  div,
  span,
  a,
  ol,
  ul,
  li,
  blockquote,
  button,
  input,
  textarea,
  select,
  radio,
  checkbox,
  form,
  pre {
    letter-spacing: ${theme.letterSpacings.normal};
    line-height: ${theme.lineHeights.normal};
    font-weight: ${theme.fontWeights.light};
    font-family: ${theme.fonts.body};
    font-size: ${theme.fontSizes.md};
  }

  pre {
    font-family: ${theme.fonts.mono};
  }

  a {
    text-decoration: underline;
    color: ${theme.colors.text};
  }

  img {
    max-width: 100%;
  }
`;
